import { backoffAuthCall } from 'core_main/api/pubnub';
import { updateStore } from 'core_main/store';
import { getConversationPubNub, getMetaPubNub } from './instance';

/*
  This helper handles the nitty-gritty of refreshing the Pubnub grant token based on the ttl
*/
let authTokenInterval: NodeJS.Timeout;
let authTokenExpiration: Date;

export function computeGrantTokenExpiration(ttl: number) {
  const buffer = ttl / 10;
  return ttl - buffer;
}

export function refreshGrantToken(outboundChatEnabled) {
  return backoffAuthCall({ version: 2, outboundChatEnabled }).then(
    (authResponse) => {
      // return without continuing to initialize the pubnub instance
      // because the auth returned an empty response which means there are no existing conversations
      if (!authResponse) return undefined;
      getMetaPubNub()?.instance?.setToken(authResponse.token);
      getConversationPubNub()?.instance?.setToken(authResponse.token);
      authTokenExpiration = new Date(
        new Date().getTime() + computeGrantTokenExpiration(authResponse.ttl),
      );
      return authResponse;
    },
  );
}
export function tryToRefreshToken(outboundChatEnabled) {
  return refreshGrantToken(outboundChatEnabled).catch(() => {
    updateStore('isPubNubConnected', false);
  });
}
export function setupGrantTokenRefresh(outboundChatEnabled) {
  return refreshGrantToken(outboundChatEnabled).then((authResponse) => {
    // return without continuing to initialize the pubnub instance
    // because the auth returned an empty response which means there are no existing conversations
    if (!authResponse) return undefined;
    authTokenInterval = setInterval(
      () => tryToRefreshToken(outboundChatEnabled),
      computeGrantTokenExpiration(authResponse.ttl),
    );
    return authResponse;
  });
}

export function isAuthTokenExpired() {
  return authTokenExpiration && new Date() > authTokenExpiration;
}

export function teardownGrantTokenRefresh() {
  clearInterval(authTokenInterval);
}
